export const MODAL_TITLE_ID = 'expandedErrorLogId';
export const BUTTON_TEXT_ID = 'copyErrorLogId';
export const NO_INTERNAL_ERRORS = 'No Internal Errors.';
export const NO_EXTERNAL_ERRORS = 'No External Errors.';
export const ASSET_NOT_PROVIDED = 'Asset Has Not Been Provided.';
export const MODAL_TITLE_DEFAULT = 'Expanded Error Log';
export const BUTTON_TEXT_DEFAULT = 'Copy and Close';
